import { IOption } from "~/components/form/FormTypes"
import { IListState } from "~/state/types"
import { _get } from "./lodash"
import { MenuItem } from "~/types/menu"
import { IBreadcrumbItemState } from "~/store/types"
export class ArrayHelper {
  static toArray<T>(value: any): (T | any)[] {
    return Array.from(value || [])
  }

  static isEmpty(value: any): boolean {
    return this.toArray(value).length === 0
  }

  static isExist(data: any[], value: any): boolean {
    let isHas = false

    ArrayHelper.toArray(data).forEach((item) => {
      if (item === value) {
        isHas = true
      }
    })

    return isHas
  }

  static toStatus = <T>(obj: IListState<T>): IListState<T> => ({
    isError: obj.isError,
    isSuccess: obj.isSuccess,
    isLoading: obj.isLoading,
    isLoaded: obj.isLoaded,
    errorData: obj.errorData,
    options: obj.options,
    items: obj.items,
  })

  static toOptions<T = any>(
    data: T[],
    valueAttr: string = "id",
    labelAttr: string = "name",
    prefixLabel = ""
  ): IOption[] {
    return ArrayHelper.toArray(data).map((item: any) => {
      const value = _get(item, valueAttr, null)
      return {
        value: value,
        label: `${prefixLabel && `${prefixLabel}: `}${_get(
          item,
          labelAttr,
          value
        )}`,
      }
    })
  }

  static createBreadCrumb(
    list: (MenuItem | undefined)[]
  ): IBreadcrumbItemState[] {
    const result = list
      .filter((i) => i !== undefined)
      .map((item) => {
        return {
          name: item?.name || "",
          isActive: false,
          to: item?.to,
        }
      })

    result[result.length - 1].isActive = true

    return result
  }
}
